/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ submitted: NonNullable<unknown>, total: NonNullable<unknown> }} Decks_Submitted_CountInputs */



/**
* | output |
* | --- |
* | "{submitted} / {total} submitted" |
*
* @param {Decks_Submitted_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_submitted_count = /** @type {((inputs: Decks_Submitted_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Submitted_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.submitted} / ${i?.total} soumis`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.submitted} / ${i?.total} enviados`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.submitted} / ${i?.total} enviados`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.submitted} / ${i?.total} inviati`)
	return /** @type {LocalizedString} */ (`${i?.submitted} / ${i?.total} submitted`)
});